
import card from '~/mixins/card'
export default {
    mixins: [card],
    computed: {
        // An AEP MAPD -> MAPD switch compares the client's current MAPD with
        // each option's new one (2026-10-07); otherwise the summary's combos
        // and the employer plans, as before.
        displayPlans () {
            const mapds = this.$store.getters.summaryAep ? this.$store.getters.aepMapdCompare : []
            if (mapds.length > 1) {
                return mapds.map(p => [p])
            }
            return [...(this.summaryCombosOrderedAsCards.length ? this.summaryCombosOrderedAsCards : this.summaryCombos), ...this.summaryUserGroupPlansList].filter(combo => combo)
        },
    },
}
